<div class="loader" [ngClass]="{'background': background}" *ngIf="display">
    <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>